import { Separator } from "@/components/ui/separator";
import { useMobile } from "@/hooks/useMedia";
import { LoginModal } from "@/lib/auth/login-modal";
import { authStore } from "@/lib/auth/store";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages";
import { localizeHref } from "@/paraglide/runtime";
import NiceModal from "@ebay/nice-modal-react";
import { Link, useLocation } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { CreateIcon } from "../icons";
import { EditIcon2, PublishIcon } from "../icons";
import { CreationIcon, CreationLightIcon } from "../icons/header";
import { CardTooltip } from "../ui/card-tooltip";

export function EditBtn() {
	const location = useLocation();
	const isMobile = useMobile();
	const navs = [
		{
			name: m.start_creation(),
			href: "/edit/$id",
			icon: <CreateIcon className="w-4 h-4 min-w-4 min-h-4" />,
			params: { id: "new" },
		},
		{
			name: m.my_draft(),
			href: "/profile/creation?tab=draft",
			icon: <EditIcon2 className="w-4 h-4 min-w-4 min-h-4" />,
		},
		{
			name: m.my_published(),
			href: "/profile/creation?tab=publish",
			icon: <PublishIcon className="w-4 h-4 min-w-4 min-h-4" />,
		},
	];
	const user = useStore(authStore, (state) => state.user);
	function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
		if (!user) {
			e.preventDefault();
			NiceModal.show(LoginModal);
		}
	}
	return (
		<CardTooltip
			className={cn("min-w-42.5 p-0 mt-2")}
			triggerClassName={cn(isMobile && "!h-40")}
			trigger={
				<div>
					<div className="flex flex-row items-center gap-2 group cursor-pointer">
						<CreationIcon
							className={cn(
								"w-[22px] h-[22px] min-w-4 min-h-4 dark:[&>path]:fill-t1 group-hover:hidden",
								location.pathname.startsWith(localizeHref("/edit")) && "hidden",
							)}
						/>
						<CreationLightIcon
							className={cn(
								"w-[22px] h-[22px] min-w-4 min-h-4 hidden group-hover:block",
								location.pathname.startsWith(localizeHref("/edit")) && "block",
							)}
						/>
						<span
							className={cn(
								"group-hover:text-main1",
								location.pathname.startsWith(localizeHref("/edit")) &&
									"text-main1",
							)}
						>
							{m.creation()}
						</span>
					</div>
					{isMobile && (
						<div className="flex flex-col gap-6 pl-7 pt-6">
							{navs.map((nav) => (
								<Link
									key={nav.href}
									to={localizeHref(nav.href)}
									params={nav.params}
									className="flex items-center gap-2"
									onClick={handleClick}
								>
									{nav.icon}
									{nav.name}
								</Link>
							))}
						</div>
					)}
				</div>
			}
			label={
				!isMobile && (
					<div className="py-1">
						{navs.map((nav, idx) => (
							<Link
								key={nav.href}
								to={localizeHref(nav.href)}
								params={nav.params}
								className=""
								onClick={handleClick}
							>
								<div
									className={cn(
										"flex items-center gap-2 text-t2 h-8 rounded-[6px] m-1 px-4 last:mb-0 hover:bg-c1",
										idx === 0 && "mt-0",
									)}
								>
									{nav.icon}
									{nav.name}
								</div>

								{idx < navs.length - 1 && <Separator className="h-10.5" />}
							</Link>
						))}
					</div>
				)
			}
		/>
	);
}
